import React, { useEffect, useState } from "react"
import { GreenBackgroundBtn, GreenToBackBtn } from "../../components/btns"
import { useAppDispatch, useAppSelector } from "../../redux/hooks"
import NewsTextEditor from "../../components/new/newsTextEditor"
import { fetchCategories } from "../../redux/categories"
import Select from "react-select"
import { useNavigate, useParams } from "react-router-dom"
import { Controller, useForm } from "react-hook-form"
import { fetchNewsCategories } from "../../redux/news/news-categories"
import { EditNews, addNews, fetchNewsById } from "../../redux/news"

const EditNewsPage = () => {
  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      borderRadius: "10px",
      cursor: "pointer",
      background: "#fff",
      marginRight: "1px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      outline: "none",
      color: "#CCC",
      boxShadow: state.isFocused ? 0 : 0,
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? "rgba(157, 194, 81, 0.5)"
        : "transparent", // LC Green color on focus
      color: "black",
      boxShadow: state.isFocused ? 0 : 0,
      "&:hover": {
        border: state.isFocused ? 0 : 0,
      },
    }),
  }
  const dispatch = useAppDispatch()
  const navigate: any = useNavigate()
  const { id }: any = useParams()
  const { news, newsCategories } = useAppSelector((state: any) => state)
  const { handleSubmit, register, control, setValue } = useForm()

  const [image, setImage] = useState<any>(false)
  const [content, setContent] = useState<any>("")

  useEffect(() => {
    dispatch(fetchCategories())
    dispatch(fetchNewsCategories())
    dispatch(
      fetchNewsById(id, (data: any) => {
        setValue("title", data?.title)
        setValue("description", data?.description)
        setValue("category", {
          value: data?.category_name,
          label: data?.category_name,
          id: data?.category,
        })
        setValue(
          "type",
          data?.type === "news"
            ? { value: "news", label: "Новости" }
            : { value: "discount", label: "Акции" },
        )
        setValue("released_date", data?.released_date)
      }),
    )
  }, [])

  const newsAvatarEdit = (e: any) => {
    dispatch(EditNews({ image: e.target.files[0] }, id))
  }

  const newsEditPublic = (data: any) => {
    dispatch(
      EditNews(
        {
          ...data,
          content: content ? content : news?.data?.content,
          type: data?.type?.value,
          category: data?.category?.id,
          is_published: true,
        },
        id,
        () => {
          navigate(-1)
        },
      ),
    )
  }

  const newsEditHide = (data: any) => {
    dispatch(
      EditNews(
        {
          ...data,
          content: content ? content : news?.data?.content,
          type: data?.type?.value,
          category: data?.category?.id,
          is_published: false,
        },
        id,
        () => {
          navigate(-1)
        },
      ),
    )
  }

  const options = [
    { value: "discount", label: "Акции" },
    { value: "news", label: "Новости" },
  ]

  return (
    <>
      <div className="AddNewsPage">
        <div className="AddNewsPage_header">
          <div onClick={() => navigate(-1)}>
            <GreenBackgroundBtn title="Назад" />
          </div>
          <div
            className="NewsCard_image-date edit"
            style={
              news?.data?.is_published === true
                ? { color: "#83C251", borderColor: "#83C251" }
                : { color: "#EB5757", borderColor: "#EB5757" }
            }
          >
            {news?.data?.is_published === true ? `Опубликован` : "Черновик"}
          </div>
          <div className="AddNewsPage_createNews">
            <h1
              className="AddNewsPage_createNews_title"
              style={{ color: "#666", fontSize: "24px" }}
            >
              Создание новости
            </h1>
          </div>
        </div>
        <div style={{ height: "100%" }}>
          <div
            className="AddNewsPage_center"
            style={{ overflowY: "scroll", height: "calc(100% - 50px)" }}
          >
            <form
              className="AddNewsPage_center-form"
              style={{ height: "fit-content" }}
            >
              <div
                className="AddNewsPage_center-form-right"
                style={{ maxWidth: "304px" }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    height: "100%",
                  }}
                >
                  <div className="AddNewsPage_center-form-right-top">
                    <div
                      className="AddNewsPage_center-form-right-top-title"
                      style={{
                        border: `0.5px solid ${
                          news?.error?.title ? "red" : "#CCC"
                        }`,
                      }}
                    >
                      <div>
                        <input
                          type="text"
                          placeholder="Название"
                          {...register("title")}
                          style={{
                            borderBottom: `1px solid #CCC`,
                            padding: "5px 0px",
                            width: "100%",
                            marginBottom: "5px",
                          }}
                        />
                      </div>
                    </div>
                    <br />
                    <div
                      className="AddNewsPage_center-form-right-top-title"
                      style={{
                        border: `0.5px solid ${
                          news?.error?.description ? "red" : "#CCC"
                        }`,
                      }}
                    >
                      <div>
                        <input
                          maxLength={250}
                          type="text"
                          placeholder="Описание"
                          {...register("description")}
                          style={{
                            borderBottom: `1px solid #CCC`,
                            padding: "5px 0px",
                            width: "100%",
                            marginBottom: "5px",
                          }}
                        />
                      </div>
                    </div>
                    <br />
                    <div
                      style={{
                        border: `0.5px solid ${
                          news?.error?.image ? "red" : "#CCC"
                        }`,
                      }}
                      className={` AddNewsPage_center-form-right-top-uploadImage `}
                    >
                      {news?.data?.image && (
                        <img
                          src={
                            news?.data?.image
                              ? news?.data?.image
                              : URL.createObjectURL(image)
                          }
                          alt="Selected"
                          className="imageUpload"
                        />
                      )}
                      <div>
                        <h1>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="64"
                            height="64"
                            viewBox="0 0 64 64"
                            fill="none"
                          >
                            <path
                              d="M56 10.6667H18.6667C17.9594 10.6667 17.2811 10.9477 16.781 11.4478C16.2809 11.9479 16 12.6262 16 13.3334V21.3334H29.3333V16.0001H45.3333V42.6667H56C56.7072 42.6667 57.3855 42.3858 57.8856 41.8857C58.3857 41.3856 58.6667 40.7073 58.6667 40.0001V13.3334C58.6667 12.6262 58.3857 11.9479 57.8856 11.4478C57.3855 10.9477 56.7072 10.6667 56 10.6667V10.6667ZM24.6667 19.2501C24.6667 19.449 24.5876 19.6398 24.447 19.7804C24.3063 19.9211 24.1156 20.0001 23.9167 20.0001H21.4167C21.2177 20.0001 21.027 19.9211 20.8863 19.7804C20.7457 19.6398 20.6667 19.449 20.6667 19.2501V16.7501C20.6667 16.5512 20.7457 16.3604 20.8863 16.2198C21.027 16.0791 21.2177 16.0001 21.4167 16.0001H23.9167C24.1156 16.0001 24.3063 16.0791 24.447 16.2198C24.5876 16.3604 24.6667 16.5512 24.6667 16.7501V19.2501ZM54 36.5834C54 36.7823 53.921 36.9731 53.7803 37.1137C53.6397 37.2544 53.4489 37.3334 53.25 37.3334H50.75C50.5511 37.3334 50.3603 37.2544 50.2197 37.1137C50.079 36.9731 50 36.7823 50 36.5834V34.0834C50 33.8845 50.079 33.6937 50.2197 33.5531C50.3603 33.4124 50.5511 33.3334 50.75 33.3334H53.25C53.4489 33.3334 53.6397 33.4124 53.7803 33.5531C53.921 33.6937 54 33.8845 54 34.0834V36.5834ZM54 27.9167C54 28.1157 53.921 28.3064 53.7803 28.4471C53.6397 28.5877 53.4489 28.6667 53.25 28.6667H50.75C50.5511 28.6667 50.3603 28.5877 50.2197 28.4471C50.079 28.3064 50 28.1157 50 27.9167V25.4167C50 25.2178 50.079 25.0271 50.2197 24.8864C50.3603 24.7458 50.5511 24.6667 50.75 24.6667H53.25C53.4489 24.6667 53.6397 24.7458 53.7803 24.8864C53.921 25.0271 54 25.2178 54 25.4167V27.9167ZM54 19.2501C54 19.449 53.921 19.6398 53.7803 19.7804C53.6397 19.9211 53.4489 20.0001 53.25 20.0001H50.75C50.5511 20.0001 50.3603 19.9211 50.2197 19.7804C50.079 19.6398 50 19.449 50 19.2501V16.7501C50 16.5512 50.079 16.3604 50.2197 16.2198C50.3603 16.0791 50.5511 16.0001 50.75 16.0001H53.25C53.4489 16.0001 53.6397 16.0791 53.7803 16.2198C53.921 16.3604 54 16.5512 54 16.7501V19.2501ZM40 24.0001H7.99999C7.29275 24.0001 6.61447 24.281 6.11438 24.7811C5.61428 25.2812 5.33333 25.9595 5.33333 26.6667L5.33333 50.6667C5.33333 51.374 5.61428 52.0523 6.11438 52.5524C6.61447 53.0525 7.29275 53.3334 7.99999 53.3334H40C40.7072 53.3334 41.3855 53.0525 41.8856 52.5524C42.3857 52.0523 42.6667 51.374 42.6667 50.6667V26.6667C42.6667 25.9595 42.3857 25.2812 41.8856 24.7811C41.3855 24.281 40.7072 24.0001 40 24.0001ZM13.3333 29.3334C13.8607 29.3334 14.3763 29.4898 14.8148 29.7828C15.2534 30.0758 15.5952 30.4923 15.797 30.9796C15.9988 31.4669 16.0517 32.003 15.9488 32.5203C15.8459 33.0376 15.5919 33.5128 15.2189 33.8857C14.846 34.2586 14.3709 34.5126 13.8536 34.6155C13.3363 34.7184 12.8001 34.6656 12.3128 34.4638C11.8256 34.2619 11.4091 33.9201 11.1161 33.4816C10.8231 33.0431 10.6667 32.5275 10.6667 32.0001C10.6667 31.2928 10.9476 30.6146 11.4477 30.1145C11.9478 29.6144 12.6261 29.3334 13.3333 29.3334ZM37.3333 48.0001H10.6667V45.3334L16 40.0001L18.6667 42.6667L29.3333 32.0001L37.3333 40.0001V48.0001Z"
                              fill="#333333"
                            />
                          </svg>
                        </h1>
                      </div>
                      <br />
                      <div>
                        {/* <h1>Нажмите, чтобы загрузить или перетащите</h1> */}
                        <h2>Макс. Размер файла: 30MB</h2>
                      </div>
                      <br />
                      <div
                        className={` AddNewsPage_center-form-right-top-uploadImage-btn `}
                      >
                        <p>Загрузить</p>{" "}
                        <input
                          type="file"
                          id="image"
                          accept="image/*"
                          onChange={(e: any) => newsAvatarEdit(e)}
                        />
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="13"
                          height="12"
                          viewBox="0 0 13 12"
                          fill="none"
                        >
                          <path
                            d="M3.80432 1.00636C4.48382 0.420342 5.43019 0 6.5 0C8.51768 0 10.1925 1.49958 10.3743 3.43424C11.5686 3.60308 12.5 4.60242 12.5 5.82955C12.5 7.17712 11.3767 8.25 10.0156 8.25H8C7.79289 8.25 7.625 8.08211 7.625 7.875C7.625 7.66789 7.79289 7.5 8 7.5H10.0156C10.9845 7.5 11.75 6.74132 11.75 5.82955C11.75 4.91777 10.9845 4.15909 10.0156 4.15909H9.64062V3.78409C9.64062 2.1192 8.24548 0.75 6.5 0.75C5.62818 0.75 4.8519 1.09329 4.29415 1.57432C3.72673 2.06368 3.42969 2.65372 3.42969 3.11591V3.45195L3.09566 3.48866C2.04778 3.60384 1.25 4.46449 1.25 5.48864C1.25 6.58869 2.17295 7.5 3.33594 7.5H5C5.20711 7.5 5.375 7.66789 5.375 7.875C5.375 8.08211 5.20711 8.25 5 8.25H3.33594C1.78065 8.25 0.5 7.02449 0.5 5.48864C0.5 4.16634 1.4494 3.07134 2.70667 2.79375C2.8136 2.14628 3.22989 1.50177 3.80432 1.00636Z"
                            fill="white"
                          />
                          <path
                            d="M6.23484 11.8902C6.38128 12.0366 6.61872 12.0366 6.76517 11.8902L9.01517 9.64017C9.16161 9.49372 9.16161 9.25628 9.01517 9.10983C8.86872 8.96339 8.63128 8.96339 8.48483 9.10983L6.875 10.7197V4.125C6.875 3.91789 6.70711 3.75 6.5 3.75C6.29289 3.75 6.125 3.91789 6.125 4.125V10.7197L4.51516 9.10983C4.36872 8.96339 4.13128 8.96339 3.98484 9.10983C3.83839 9.25628 3.83839 9.49372 3.98484 9.64017L6.23484 11.8902Z"
                            fill="white"
                          />
                        </svg>
                      </div>{" "}
                    </div>
                    <br />
                    {news?.data?.image ? (
                      <label htmlFor="image">
                        {" "}
                        <div className="AddNewsPage_center-form-right-bottom-greenBG">
                          Загрузить другое фото
                        </div>
                      </label>
                    ) : null}

                    <div className="AddNewsPage_center-form-right-top-selekt">
                      <div className="form_inputs-input">
                        {/* <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <p style={{ color: "black" }}>Тема:</p>
                        </div>

                        <div style={{ marginLeft: "1.5rem" }}>
                          <div>
                            <Controller
                              control={control}
                              {...register("type")}
                              render={({ field }) => (
                                <Select
                                  styles={customStyles}
                                  placeholder="Выбрать"
                                  {...field}
                                  // onChange={(e) => handleSelectChange(e)}
                                  options={options?.map((item: any) => ({
                                    value: item?.value,
                                    label: item?.label,
                                  }))}
                                />
                              )}
                            />
                            <div
                              className="error"
                              style={{ paddingTop: "5px" }}
                            >
                              {news?.error?.type}
                            </div>
                          </div>
                        </div> */}
                      </div>
                      <div className="form_inputs-input">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <p
                            style={{
                              color: ` ${
                                news?.error?.category ? "red" : "black"
                              }`,
                            }}
                          >
                            Категория:
                          </p>
                        </div>

                        <div style={{ marginLeft: "1.5rem" }}>
                          <div>
                            <Controller
                              control={control}
                              {...register("category")}
                              render={({ field }) => (
                                <Select
                                  styles={customStyles}
                                  placeholder="Выбрать"
                                  {...field}
                                  // onChange={(e) => handleSelectChange(e)}
                                  options={newsCategories?.data?.map(
                                    (item: any) => ({
                                      value: item?.name,
                                      label: item?.name,
                                      id: item?.id,
                                    }),
                                  )}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="form_inputs-input">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <p
                            style={{
                              color: `${
                                news?.error?.released_date ? "red" : "black"
                              }`,
                            }}
                          >
                            Дата публикации:
                          </p>
                        </div>

                        <div style={{ marginLeft: "1.5rem" }}>
                          {/* <SelectInput
                        error={error}
                        placeholder="Дата публикации:"
                        setState={() => console.log()}
                        state={[]}
                        options={options}
                      /> */}
                          <div>
                            <input
                              // onChange={handleDateChage}
                              style={{ width: "133px" }}
                              className="form_inputs-input-text"
                              {...register("released_date")}
                              type="date"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="AdddNewsPage_center-form-right-bottom">
                    <div
                      onClick={handleSubmit(newsEditHide)}
                      className="AddNewsPage_center-form-right-bottom-whitebg"
                    >
                      Сохранить как черновик
                    </div>

                    <div
                      onClick={handleSubmit(newsEditPublic)}
                      className="AddNewsPage_center-form-right-bottom-greenBG"
                    >
                      {true ? "Опубликовать" : "Сохранить"}
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  maxWidth: "850px",
                }}
              >
                {news?.data?.content && (
                  <NewsTextEditor
                    value={news?.data?.content}
                    onChange={(e) => {
                      setContent(e)
                    }}
                    style={{
                      border: `1px solid ${
                        news?.error?.content ? "red" : "#CCC"
                      }`,
                    }}
                  />
                )}
              </div>
            </form>
          </div>
        </div>
      </div>{" "}
    </>
  )
}

export default EditNewsPage
